import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.scss'],
})
export class DashboardHomeComponent implements OnInit {

  userName$ = new BehaviorSubject<string | undefined>(undefined);
  isOneTankAdmin = false;
  isCustomer = false;
  isManufacturing = false;

  constructor(
    private _authorizeService: AuthorizeService,
    private _router: Router,) {

  }

  ngOnInit() {

    this._authorizeService.user$.subscribe(user => {
      this.userName$.next(user?.firstName + " " + user?.lastName);

      if (user?.roleName?.includes("One-Tank Admin"))
        this.isOneTankAdmin = true;
      if (user?.roleName?.includes("Customer"))
        this.isCustomer = true;

      if (user?.roleName?.includes('Manufacturing') && !user?.roleName?.includes('ManufacturingAdmin'))
        this.isManufacturing = true;
      
    });

  }

}
